import React from "react";
import { Typography, Box, Stack } from "@mui/material";
import { motion } from "framer-motion";

const degrees = [
    {
        title: "M.S. Information Systems and Management",
        school: "University of Texas at Dallas",
        years: "2016 – 2018",
        accent: "#0077ff",
    },
    {
        title: "B.E. Mechanical Engineering",
        school: "Anna University",
        years: "2009 – 2013",
        accent: "#8a92a0",
    },
];

const Education: React.FC = () => (
    <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
    >
        <Typography
            sx={{
                fontFamily: "'DM Mono', monospace",
                fontSize: "11px",
                letterSpacing: "0.2em",
                textTransform: "uppercase",
                color: "primary.main",
                mb: 0.75,
            }}
        >
            Background
        </Typography>
        <Typography variant="h4" sx={{ mb: 3, letterSpacing: "-0.02em" }}>
            Education
        </Typography>

        <Stack spacing={1.5}>
            {degrees.map((deg, i) => (
                <Box
                    key={i}
                    sx={{
                        border: "1px solid",
                        borderColor: "divider",
                        borderLeft: `3px solid ${deg.accent}`,
                        borderRadius: 2,
                        p: 2.5,
                        bgcolor: "background.paper",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        gap: 2,
                        transition: "border-color 0.2s",
                        "&:hover": { borderColor: "rgba(255,255,255,0.13)" },
                    }}
                >
                    <Box>
                        <Typography variant="h6" sx={{ letterSpacing: "-0.01em", lineHeight: 1.2, mb: 0.3 }}>
                            {deg.title}
                        </Typography>
                        <Typography sx={{ fontFamily: "'DM Mono', monospace", fontSize: "11px", color: deg.accent }}>
                            {deg.school}
                        </Typography>
                    </Box>
                    <Typography sx={{ fontFamily: "'DM Mono', monospace", fontSize: "11px", color: "text.secondary", flexShrink: 0 }}>
                        {deg.years}
                    </Typography>
                </Box>
            ))}
        </Stack>
    </motion.div>
);

export default Education;
